import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import NameForm from "./components/nameForm";
import AuthPage from "./pages/authPage";
import MainPage from "./pages/mainPage";
import CarForm from "./pages/mainPage/carForm";
import SingleCarPage from "./pages/singleCarPage";
import ExpenseForm from "./pages/singleCarPage/expenseList/expenseForm";
import { useMe } from "./zustand/store";
import FinancePage from "./pages/mainPage/financePage";
import FinanceForm from "./pages/mainPage/financePage/financeForm";
import CarsPage from "./pages/mainPage/carsPage";
import AccountPage from "./pages/mainPage/accountPage";

function App() {
  const me = useMe();

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/car" replace={true} />} />
        <Route element={<MainPage />}>
          <Route path="/car" element={<CarsPage />} />
          <Route path="/finance" element={<FinancePage />} />
          <Route path="/me" element={<AccountPage />} />
        </Route>
        <Route path="/finance/new" element={<FinanceForm />} />
        <Route path="/finance/:id" element={<FinanceForm />} />
        <Route path="/finance/:id/edit" element={<FinanceForm />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/car/new" element={<CarForm />} />
        <Route path="/car/:id" element={<SingleCarPage />} />
        <Route path="/car/:id/edit" element={<CarForm />} />
        <Route path="/car/:id/expense/new" element={<ExpenseForm />} />
        <Route path="/car/:id/expense/:eId" element={<ExpenseForm />} />
        <Route path="/car/:id/expense/:eId/edit" element={<ExpenseForm />} />
      </Routes>

      {me?.success && !me?.data?.name && <NameForm />}
    </>
  );
}

export default App;
